import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './App.css';
import './WatchReportPage.css';
import Navigation from './Navigation';

export default function ReportLookupPage() {
  const [userId, setUserId] = useState('');
  const [watchId, setWatchId] = useState('');
  const navigate = useNavigate();

  const go = (e) => {
    e.preventDefault();
    const u = userId.trim();
    if (!u) return;
    const w = watchId.trim();
    navigate(w ? `/analytics/${u}/${w}` : `/analytics/${u}`);
  };

  return (
    <div className="report-page">
      <Helmet>
        <title>Report Lookup — ChronoLog</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Navigation />
      <main className="report-main" style={{ maxWidth: 560 }}>
        <header className="report-hero">
          <p className="report-kicker">ChronoLog Reports</p>
          <h1>Open a report</h1>
        </header>
        <form className="report-card" onSubmit={go}>
          <label className="report-tile-label" htmlFor="lookup-user">User ID</label>
          <input
            id="lookup-user"
            className="report-lookup-input"
            value={userId}
            onChange={e => setUserId(e.target.value)}
            placeholder="e.g. 01kv8ey0s9qjb14tbyxnahjjhp"
            autoFocus
            spellCheck={false}
            autoComplete="off"
          />
          <label className="report-tile-label" htmlFor="lookup-watch" style={{ marginTop: '0.8rem', display: 'block' }}>
            Watch ID <span style={{ textTransform: 'none', letterSpacing: 0 }}>(optional — leave blank for the collection)</span>
          </label>
          <input
            id="lookup-watch"
            className="report-lookup-input"
            value={watchId}
            onChange={e => setWatchId(e.target.value)}
            placeholder="e.g. 01kjns2gp96ds91r6nqm19wc67"
            spellCheck={false}
            autoComplete="off"
          />
          <button type="submit" className="report-lookup-button" disabled={!userId.trim()}>
            View report
          </button>
        </form>
      </main>
    </div>
  );
}
